import { DOCUMENT } from '../enums'

const DOCUMENTS_NEEDED_LIST = [
  DOCUMENT.PROOF_IDENTITY,
  DOCUMENT.INCOME_STATEMENT,
  DOCUMENT.PROOF_RESIDENCE,
]

const DOCUMENTS_NEEDED_HEADERS = {
  [DOCUMENT.PROOF_IDENTITY]: {
    title: 'Documento de identidade',
    subtitle: 'Frente e verso do RG, CNH, RNM, RNE ou documento de classe.',
  },
  [DOCUMENT.INCOME_STATEMENT]: {
    title: 'Comprovante de renda',
    subtitle:
      'Holerite dos últimos 3 meses, extrato bancário e extrato benefício.',
  },
  [DOCUMENT.PROOF_RESIDENCE]: {
    title: 'Comprovante de residência',
    subtitle: 'Conta de consumo como água, luz, gás, telefone ou TV a cabo.',
  },
}

export { DOCUMENTS_NEEDED_LIST, DOCUMENTS_NEEDED_HEADERS }
